import React from 'react'
import Carousel from 'react-multi-carousel';

export const CountryFlagCenterMembership = () => {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 1700, min: 1200 },
            items: 8
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 4
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 2
        }
    };

  return (
    <section className="brand-one">
                <div className="container">
           
                    <h2
                        className
                        =
                        "brand-one__text count-box section-title__title"
                    > Connect <span  className='global---'>Globally</span>, Grow <span  className='global---'>Locally</span></h2>
                    <p className='global-flags'>Enjoy the benefits of a limited number of members per country,<br/>ensuring that you have less competition and more focused business opportunities.</p>
                    <Carousel arrows={true} responsive={responsive} showDots={false} autoPlay={true} transitionDuration={200} infinite={true}>

                        <div className="swiper-slide">
                            <img src="images/country-flags/afghanistan.png" alt="afghanistan"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/belgium.png" alt="belgium"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/uzbekistan.png" alt="uzbekistan"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/us.png" alt="united-states-of-america"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/london.png" alt="london"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/uae.png" alt="united-arab-emirates"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/turkish.png" alt="turkish"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/thailand.png" alt="thailand"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/spain.png" alt="spain"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/singapore.png" alt="Singapore"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/portugal.png" alt="portugal"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/poland.png" alt="poland"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/pakistan.png" alt="pakistan"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/oman.png" alt="oman"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/kenya.png" alt="kenya"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/japan.png" alt="japan"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/italy.png" alt="italy"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/india.png" alt="india"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/germany.png" alt="germany"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/france.png" alt="france"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/canada.png" alt="canada"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/brazilian.png" alt="brazilian"></img>
                        </div>
                        <div className="swiper-slide">
                            <img src="images/country-flags/benin.png" alt="benin"></img>
                        </div>
                    </Carousel>
                </div>
            </section>
  )
}
